import { render, staticRenderFns } from "./SectionAgeFrom2022.vue?vue&type=template&id=d10307e4"
import script from "./SectionAgeFrom2022.vue?vue&type=script&lang=ts"
export * from "./SectionAgeFrom2022.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports